export const MOBILITY_FIELD_CHANGE = 'MOBILITY_FIELD_CHANGE';
export const MOBILITY_SAVE = 'MOBILITY_SAVE';
export const MOBILITY_SAVE_PENDING = 'MOBILITY_SAVE_PENDING';
